import { useEffect, useRef } from "react";

import { AmplitudeEvents } from "@/common/constants/amplitude";
import { useLiveFormAmplitudeEvents } from "@/features/LiveFormEditor/common/amplitude/useLiveFormAmplitudeEvents";
import { AiDescriptionWizardExperiment } from "@/features/LiveFormEditor/Steps/StepDescription/StepDescriptionAiWizard/helpers/useAiDescriptionWizardExperiment";

export const useLogAiDescriptionWizardStepViewed = ({
  isEligible,
  experiment,
}: {
  isEligible: boolean;
  experiment: AiDescriptionWizardExperiment;
}): void => {
  const { logUserActionEvent } = useLiveFormAmplitudeEvents();
  const hasLoggedRef = useRef(false);

  useEffect(() => {
    if (hasLoggedRef.current || !isEligible || experiment.loading) {
      return;
    }

    hasLoggedRef.current = true;
    logUserActionEvent(AmplitudeEvents.AiDescriptionWizardStepViewed, {
      variant: experiment.variant ?? "unresolved",
      has_npo_context: experiment.hasNpoContext,
      wizard_shown: experiment.isWizardEnabled,
      is_experiment_resolved: experiment.isResolved,
    });
  }, [isEligible, experiment, logUserActionEvent]);
};
